export default __webpack_public_path__ + "eff41ba8fb1b647baa9f046a968ffd42.png";